"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _helpers = require("@qwkin/helpers");
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _styledComponents = require("styled-components");
var _DocumentUploader = require("./DocumentUploader.styles");
var _Text = _interopRequireDefault(require("../Text/Text"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));
var _S3PrivateImage = _interopRequireDefault(require("../S3PrivateImage/S3PrivateImage"));
var _theme = require("../utils/theme");
var _excluded = ["children", "title", "id", "value", "label", "noFileLabel", "icon", "fileIcon", "accept", "message", "onChange", "s3PreviewKey", "s3PreviewBucket", "s3ZoomPreviewKey", "s3ZoomPreviewBucket", "width", "height", "theme"];
var DocumentUploader = function DocumentUploader(_ref) {
  var children = _ref.children,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Document Upload' : _ref$title,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'uploadFileInput' : _ref$id,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Upload file' : _ref$label,
    _ref$noFileLabel = _ref.noFileLabel,
    noFileLabel = _ref$noFileLabel === void 0 ? 'No file selected' : _ref$noFileLabel,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'add-document' : _ref$icon,
    _ref$fileIcon = _ref.fileIcon,
    fileIcon = _ref$fileIcon === void 0 ? 'document' : _ref$fileIcon,
    _ref$accept = _ref.accept,
    accept = _ref$accept === void 0 ? ['.jpg', '.jpeg', '.png', '.pdf', '.docx', '.doc', '.xls', '.xlsx'] : _ref$accept,
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'You can drag the document from your computer here to upload it.' : _ref$message,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _helpers.identity : _ref$onChange,
    s3PreviewKey = _ref.s3PreviewKey,
    s3PreviewBucket = _ref.s3PreviewBucket,
    s3ZoomPreviewKey = _ref.s3ZoomPreviewKey,
    s3ZoomPreviewBucket = _ref.s3ZoomPreviewBucket,
    width = _ref.width,
    height = _ref.height,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var handleUploadFileButton = function handleUploadFileButton() {
    return document.getElementById(id).click();
  };
  var clearInputFile = function clearInputFile() {
    return document.getElementById(id).value = null;
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
    onDrop: function onDrop(files) {
      return onChange(files[0]);
    }
  }, function (_ref2) {
    var _value$name;
    var getRootProps = _ref2.getRootProps,
      getInputProps = _ref2.getInputProps;
    return /*#__PURE__*/_react["default"].createElement(_DocumentUploader.DropzoneContainer, (0, _extends2["default"])({}, getRootProps(), {
      width: width,
      height: height,
      onClick: _helpers.identity
    }), /*#__PURE__*/_react["default"].createElement(_DocumentUploader.DropzoneColumn, {
      style: {
        flex: 8
      }
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      type: "small",
      weight: "bold",
      style: {
        marginBottom: '8px'
      }
    }, title), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      dense: true,
      icon: icon,
      onClick: handleUploadFileButton
    }, label), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      type: "small",
      style: {
        marginTop: '8px'
      }
    }, message)), /*#__PURE__*/_react["default"].createElement(_DocumentUploader.DropzoneColumn, {
      style: {
        marginLeft: '16px',
        flex: 4,
        minWidth: '115px',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, getInputProps(), {
      id: id,
      style: {
        display: 'none'
      },
      accept: accept.join(','),
      type: "file"
    })), /*#__PURE__*/_react["default"].createElement(_DocumentUploader.FilePreviewContainer, {
      name: value === null || value === void 0 ? void 0 : value.name,
      showPreview: s3PreviewBucket && s3PreviewKey && !(value !== null && value !== void 0 && value.name)
    }, (value === null || value === void 0 ? void 0 : value.name) && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      dense: true,
      style: {
        position: 'absolute',
        top: '4px',
        right: '4px'
      },
      format: "round",
      size: "12",
      icon: "close",
      onClick: function onClick() {
        clearInputFile();
        onChange(null);
      }
    }), s3PreviewBucket && s3PreviewKey && !(value !== null && value !== void 0 && value.name) ? /*#__PURE__*/_react["default"].createElement(_S3PrivateImage["default"], {
      shouldZoom: true,
      s3Key: s3PreviewKey,
      s3Bucket: s3PreviewBucket,
      s3ZoomKey: s3ZoomPreviewKey !== null && s3ZoomPreviewKey !== void 0 ? s3ZoomPreviewKey : s3PreviewKey,
      s3ZoomBucket: s3ZoomPreviewBucket !== null && s3ZoomPreviewBucket !== void 0 ? s3ZoomPreviewBucket : s3PreviewBucket,
      style: {
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        objectFit: 'cover',
        maxHeight: '89px'
      }
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        maxWidth: '100%',
        textAlign: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      size: "55",
      icon: value ? fileIcon : icon,
      style: {
        color: value !== null && value !== void 0 && value.name ? theme.color.primary["default"] : '#333'
      }
    }), /*#__PURE__*/_react["default"].createElement(_DocumentUploader.FileName, {
      type: "small",
      style: {
        margin: '8px 0',
        color: value !== null && value !== void 0 && value.name ? theme.color.primary["default"] : '#333'
      }
    }, (_value$name = value === null || value === void 0 ? void 0 : value.name) !== null && _value$name !== void 0 ? _value$name : noFileLabel)))));
  }));
};
var _default = exports["default"] = DocumentUploader;